enum OtherRoutesPaths {
	NOT_FOUND = "*",
	UI = "ui",
	NOT_SUPPORTED = "notSupported",
	INTERNAL_SERVER_ERROR = "500",
}

export default OtherRoutesPaths;
